// ─── Category Filters (match real template categories) ───────────────────────
export const CATEGORIES = [
  { id: 'all',          label: 'All Templates' },
  { id: 'professional', label: 'Professional' },
  { id: 'it',           label: 'IT & Tech' },
  { id: 'entry-level',  label: 'Entry Level' },
  { id: 'medical',      label: 'Medical' },
];

// ─── Sort Options ─────────────────────────────────────────────────────────────
export const SORT_OPTIONS = [
  { value: 'popular',   label: 'Most Popular' },
  { value: 'ats-score', label: 'Highest ATS Score' },
  { value: 'newest',    label: 'Newest First' },
  { value: 'name',      label: 'Name A–Z' },
];

// // ─── Real Template Data (R2 CDN) ──────────────────────────────────────────────
// export const TEMPLATES = [
//   {
//     id: 'ats-compliant-resume-143d7213',
//     title: 'ATS Compliant Resume',
//     slug: 'ats-compliant-resume',
//     subtitle: 'Professional · ATS Optimised',
//     category: 'professional',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/ats-compliant-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/ats-compliant-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1iLde6pUTpxb8tCIG4U1SvHB_2uFFRmmopIa753eAP04/template/preview',
//     tags: ['Professional', 'ATS Friendly'],
//     atsScore: 99,
//     isPopular: true,
//     isFree: true,
//     description: 'Engineered to pass the strictest ATS filters used by Fortune 500 companies. Single-column, keyword-dense, zero parsing issues.',
//     overview: 'The highest ATS-scoring template in our library. Designed to pass automated filters at enterprises like Goldman Sachs, McKinsey, Google, and Accenture.',
//     tips: [
//       'Pure single-column layout - zero parsing issues across all major ATS systems',
//       'Standard section headers maximise keyword detection accuracy',
//       'No tables, graphics, or columns that legacy ATS systems struggle to parse',
//     ],
//   },
//   {
//     id: 'recent-college-graduate-resume-8c5072b7',
//     title: 'Recent College Graduate Resume',
//     slug: 'recent-college-graduate-resume',
//     subtitle: 'Entry Level · Graduate',
//     category: 'entry-level',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/recent-college-graduate-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/recent-college-graduate-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1kkLgIjonzGu2rZHMzAF7A6g3a1dzkYDFnwpkV8Z38n0/template/preview',
//     tags: ['Entry Level', 'Skills Section', 'Has Objective', 'Achievements'],
//     atsScore: 95,
//     isPopular: true,
//     isFree: true,
//     description: 'Built for fresh graduates and career starters. Education-first layout with strong projects and skills sections to compensate for limited work history.',
//     overview: 'Structured for candidates with 0–2 years of experience. Education-first layout with achievements that make entry-level candidates stand out.',
//     tips: [
//       'Education leads - maximises impact for fresh graduates and campus hires',
//       'Achievements and volunteer sections bridge the work experience gap credibly',
//       'Skills grid is ATS-optimised for keyword matching in entry-level job descriptions',
//     ],
//   },
//   {
//     id: 'senior-software-engineer-resume-58c96ce6',
//     title: 'Senior Software Engineer Resume',
//     slug: 'senior-software-engineer-resume',
//     subtitle: 'IT & Tech · Senior Level',
//     category: 'it',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/senior-software-engineer-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/senior-software-engineer-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1LCf1mCnygnpqvx34WgDga2cyT8RSOXvivTnkbvUrDyU/template/preview',
//     tags: ['IT', 'Senior Level', 'ATS Friendly'],
//     atsScore: 97,
//     isPopular: true,
//     isFree: true,
//     description: 'Optimised for senior software engineers targeting FAANG-tier and high-growth companies. Technical skills and system design achievements prominently featured.',
//     overview: 'Structured around the technical hiring process. Engineering managers and technical recruiters immediately see your stack, architecture experience, and quantified impact.',
//     tips: [
//       'Technologies section is scannable in under 3 seconds by technical recruiters',
//       'System design and architecture contributions are structurally highlighted',
//       'Open source and project links naturally drive credibility with engineering leads',
//     ],
//   },
//   {
//     id: 'clean-modern-resume-2225360b',
//     title: 'Clean Modern Resume',
//     slug: 'clean-modern-resume',
//     subtitle: 'Professional · Minimal · Modern',
//     category: 'professional',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/clean-modern-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/clean-modern-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1oUmmdZuedP3gYya6osnWger6g6gWE1dO8O-ZBd43S4A/template/preview',
//     tags: ['Professional', 'Minimal', 'Modern'],
//     atsScore: 96,
//     isPopular: false,
//     isFree: true,
//     description: 'Clean and modern layout that strikes the perfect balance between visual appeal and ATS compatibility. Minimal design that lets your experience shine.',
//     overview: 'The go-to template for professionals who want a modern look without sacrificing ATS compatibility. Works across all industries and experience levels.',
//     tips: [
//       'Clean visual hierarchy guides recruiter attention naturally down the page',
//       'Minimal design removes distractions - your content is always the focus',
//       'Optimised for both ATS parsing and human review simultaneously',
//     ],
//   },
//   {
//     id: 'product-manager-resume-02dc421f',
//     title: 'Product Manager Resume',
//     slug: 'product-manager-resume',
//     subtitle: 'IT & Tech · Product Management',
//     category: 'it',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/product-manager-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/product-manager-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1MKBvnREfrxDSKAMW2yOZAM5XN43ZNTUGSTl1hhTyppA/template/preview',
//     tags: ['IT', 'Has Summary', 'Certifications', 'Skills Section'],
//     atsScore: 95,
//     isPopular: true,
//     isFree: false,
//     description: 'Built for APMs, PMs, and Senior PMs targeting product roles at tech companies. Heavy emphasis on metrics, roadmap ownership, and user impact.',
//     overview: 'Product-role optimised template with a strong professional summary and certifications section. Preferred format by PM hiring managers at top-tier tech companies.',
//     tips: [
//       'OKR and metric framing is immediately visible - what hiring managers look for',
//       'Summary section leads with your biggest product wins before anything else',
//       'Certifications and publications sections add credibility for senior PM roles',
//     ],
//   },
//   {
//     id: 'mccombs-resume-5adebe6d',
//     title: 'McCombs Resume',
//     slug: 'mccombs-resume',
//     subtitle: 'Professional · Business School Format',
//     category: 'professional',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/mccombs-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/mccombs-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1CoaAys5AcfH2HY_9rFV3oKvj10PPCKKtwm8pQlPKN-4/template/preview',
//     tags: ['Professional', 'Business School'],
//     atsScore: 96,
//     isPopular: false,
//     isFree: false,
//     description: 'Inspired by the McCombs School of Business format. Clean, structured, and highly respected by corporate and consulting recruiters.',
//     overview: 'Based on the resume format preferred by top MBA programs and consulting firms. Strong structural hierarchy that highlights leadership and business impact.',
//     tips: [
//       'Bullet points follow a concise action-result format preferred by consulting recruiters',
//       'Clean section dividers create visual breathing room without wasting space',
//       'Leadership and activities sections are structurally included for MBA candidates',
//     ],
//   },
//   {
//     id: 'registered-nurse-resume-6d0ca2e1',
//     title: 'Registered Nurse Resume',
//     slug: 'registered-nurse-resume',
//     subtitle: 'Medical · Healthcare Professional',
//     category: 'medical',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/registered-nurse-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/registered-nurse-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1sGO5ixUftsqeeGZbrAxZayWe4mQhnL83Qh15R6iIJ24/template/preview',
//     tags: ['Medical', 'Entry Level', 'Senior Level', 'Volunteer Work'],
//     atsScore: 94,
//     isPopular: false,
//     isFree: true,
//     description: 'Tailored for registered nurses and healthcare professionals. Licenses, certifications, and clinical experience are structurally highlighted.',
//     overview: 'Healthcare-specific layout that surfaces nursing credentials, clinical rotations, and specialisations that hospital ATS systems are configured to scan for.',
//     tips: [
//       'Licenses and certifications section appears prominently above the fold',
//       'Clinical specialisations are keyword-rich for healthcare ATS configurations',
//       'Volunteer work section supports compassionate care narrative for nursing roles',
//     ],
//   },
//   {
//     id: 'it-simple-resume-54a7f7ae',
//     title: 'IT Simple Resume',
//     slug: 'it-simple-resume',
//     subtitle: 'IT & Tech · Minimal · Professional',
//     category: 'it',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/it-simple-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/it-simple-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1VBpunf_biSurNMo3joPUEq_ebd_PB9kzqR7dqr3_xTQ/template/preview',
//     tags: ['IT', 'Minimal', 'Professional'],
//     atsScore: 97,
//     isPopular: false,
//     isFree: true,
//     description: 'Clean and simple layout built for IT professionals. No clutter - just your technical skills, experience, and impact laid out for maximum readability.',
//     overview: 'The minimalist choice for IT professionals who want their technical depth to speak for itself. Every element has a reason to be there.',
//     tips: [
//       'Technical skills are immediately visible in the first scan - no digging required',
//       'Minimal design eliminates visual noise that slows down recruiter decision-making',
//       'Clean formatting ensures zero issues across all ATS and PDF readers',
//     ],
//   },
//   {
//     id: 'remote-work-resume-2-090eb5a4',
//     title: 'Remote Work Resume',
//     slug: 'remote-work-resume-2',
//     subtitle: 'Professional · Remote Friendly',
//     category: 'professional',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/remote-work-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/remote-work-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1GwtIdHhXMRz4U1yk1WlOW-atjmfxzUR3Zb0-WTg-pBE/template/preview',
//     tags: ['Professional', 'Remote Friendly'],
//     atsScore: 95,
//     isPopular: false,
//     isFree: true,
//     description: 'Designed to highlight async communication, remote collaboration, and distributed team experience - keywords that remote-first companies actively scan for.',
//     overview: 'Optimised for candidates targeting fully remote or hybrid roles. Signals remote readiness through its structure and the keywords it naturally accommodates.',
//     tips: [
//       'Remote-specific skills and tools section is prominently structured',
//       'Async communication and distributed team experience are easy to surface',
//       'Location-neutral formatting signals global remote readiness to hiring managers',
//     ],
//   },
//   {
//     id: 'traditional-simple-resume-2-2053d6e1',
//     title: 'Traditional Simple Resume',
//     slug: 'traditional-simple-resume-2',
//     subtitle: 'IT & Tech · Minimal · Entry Level',
//     category: 'it',
//     thumbnail: 'https://cdn.stabiliq.in/resume-templates/thumbnails/traditional-simple-resume.webp',
//     pdfPreview: 'https://cdn.stabiliq.in/resume-templates/pdfs/traditional-simple-resume.pdf',
//     copyUrl: 'https://docs.google.com/presentation/d/1xJlSoflaQ-HFqL49AwgyFT4evYAUNZdX9jOqquRfVTA/template/preview',
//     tags: ['IT', 'Minimal', 'Entry Level', 'Projects Section', 'Skills Section'],
//     atsScore: 96,
//     isPopular: false,
//     isFree: true,
//     description: 'A clean, traditional format with a projects section - ideal for IT professionals and developers who want to show their work without complex layouts.',
//     overview: 'Traditional structure trusted by hiring managers across all IT roles. The added projects section makes it effective for developers showcasing real-world work.',
//     tips: [
//       'Traditional format is universally accepted across all ATS systems globally',
//       'Projects section compensates for limited professional experience in junior roles',
//       'Skills section with multilingual support broadens applicability internationally',
//     ],
//   },
// ];

export const TEMPLATES = [
  {
    "id": "jakes-resume-2-d3c27f4a",
    "title": "Jake's Resume",
    "slug": "jakes-resume-2",
    "subtitle": "Finance & Business",
    "category": "finance",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/jakes-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/jakes-resume.pdf",
    "googleSlideId": "1rn7FZ6vze3fjMb6b70Dd0tQpsSdvPIzJJvdUho4wsME",
    "copyUrl": "https://docs.google.com/presentation/d/1rn7FZ6vze3fjMb6b70Dd0tQpsSdvPIzJJvdUho4wsME/template/preview",
    "tags": [
      "Finance"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for finance and business professionals who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Finance & Business roles. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems",
      "Save and submit as PDF to maintain visual formatting across all devices and platforms"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAACwAwCdASoUABwAPzmOwFcvKacjqAqp4CcJaQAALne1oSBAKv/gAAD+5yCBaY73SIAeBwS+x4Fy0mVKpxT5wAAA",
    "importedAt": "2026-06-07T15:41:28.129Z"
  },
  {
    "id": "licensed-practical-nurse-resume-2-88817af4",
    "title": "Licensed Practical Nurse Resume",
    "slug": "licensed-practical-nurse-resume-2",
    "subtitle": "Healthcare · Skills Section · Certifications",
    "category": "medical",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/licensed-practical-nurse-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/licensed-practical-nurse-resume.pdf",
    "googleSlideId": "1egajgFbFw5KKip_3aqE8NhyR5HMFx8lm294UZ4cwZ-4",
    "copyUrl": "https://docs.google.com/presentation/d/1egajgFbFw5KKip_3aqE8NhyR5HMFx8lm294UZ4cwZ-4/template/preview",
    "tags": [
      "Healthcare",
      "Skills Section",
      "Certifications",
      "Achievements"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for healthcare professionals who want to make a strong, lasting first impression.",
    "overview": "Clean clinical format structured to meet the expectations of healthcare recruiters. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve",
      "Achievements section draws recruiter attention to measurable impact and quantifiable results"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAABQAwCdASoUABwAPzmIuVOvKSWkMAgB4CcJZQAAUqaljtxpAAD+nvOgpGHr83V0yKiqcZYcR+7byBUgpgAAAA==",
    "importedAt": "2026-06-07T15:41:33.331Z"
  },
  {
    "id": "paralegal-resume-2-a6c93157",
    "title": "Paralegal Resume",
    "slug": "paralegal-resume-2",
    "subtitle": "Legal · Senior Level · Skills Section",
    "category": "legal",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/paralegal-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/paralegal-resume.pdf",
    "googleSlideId": "1TodqPN00oryCq-pYozmaUn3CXZ3eRx394ANslICmYog",
    "copyUrl": "https://docs.google.com/presentation/d/1TodqPN00oryCq-pYozmaUn3CXZ3eRx394ANslICmYog/template/preview",
    "tags": [
      "Legal",
      "Senior Level",
      "Skills Section",
      "Summary",
      "Objective",
      "Certifications",
      "Multilingual",
      "Publications",
      "Volunteer Work"
    ],
    "atsScore": 77,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a compelling professional summary - ideal for legal professionals and law students who want to make a strong, lasting first impression.",
    "overview": "Formal layout aligned with the professional expectations of law firms and legal departments. The professional summary section gives recruiters an immediate, compelling overview of your value.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Professional summary gives recruiters a compelling 5-second overview of your career value"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAAAQAwCdASoUABwAPzmQulUvKqWjMBgIAeAnCWkAADqwVgAA/u6TvgRdk0qaro55dTmR9mxj6RNUPHblmR1R6++9PcSQAAAA",
    "importedAt": "2026-06-07T15:41:37.838Z"
  },
  {
    "id": "traditional-simple-resume-17613-2-0b4526a3",
    "title": "Traditional Simple Resume #17613",
    "slug": "traditional-simple-resume-17613-2",
    "subtitle": "Professional · Minimal · Remote Friendly",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/traditional-simple-resume-17613.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/traditional-simple-resume-17613.pdf",
    "googleSlideId": "1Igm9JhFWrUbouIci7UYy7MUXW_kLDKwx_3q9LbJyxaU",
    "copyUrl": "https://docs.google.com/presentation/d/1Igm9JhFWrUbouIci7UYy7MUXW_kLDKwx_3q9LbJyxaU/template/preview",
    "tags": [
      "Professional",
      "Minimal",
      "Remote Friendly",
      "Skills Section",
      "Projects Section",
      "Multilingual"
    ],
    "atsScore": 94,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal traditional format - ideal for professionals across all industries who want to pass ATS screening and impress hiring managers.",
    "overview": "Traditional structure trusted by hiring managers across all Professional roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Traditional format is universally accepted across all major ATS systems globally",
      "High ATS score means your resume passes automated screening without formatting interference",
      "Projects section compensates for limited professional experience in junior and entry-level roles"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAABwAwCdASoUABwAPzmKulWvKSWjKA1R4CcJaQAALc+QHQHGlYAA/t76Vkf0S88QJ/vFxVpfuaJiTwyN2lGArfyAQg8kAAAA",
    "importedAt": "2026-06-07T15:41:45.926Z"
  },
  {
    "id": "software-engineer-resume-2-6ca0a385",
    "title": "Software Engineer Resume",
    "slug": "software-engineer-resume-2",
    "subtitle": "IT & Tech · Functional · Senior Level",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/software-engineer-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/software-engineer-resume.pdf",
    "googleSlideId": "1dSElNLfEheVpb9cG6zeeYe3k0Y2FFdGvfRucZGk6JP8",
    "copyUrl": "https://docs.google.com/presentation/d/1dSElNLfEheVpb9cG6zeeYe3k0Y2FFdGvfRucZGk6JP8/template/preview",
    "tags": [
      "IT & Tech",
      "Functional",
      "Senior Level",
      "Skills Section",
      "Projects Section"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a dedicated projects section - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Structure designed to highlight leadership trajectory, strategic roles, and career progression"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmAAAABXRUJQVlA4IFQAAAAwBACdASoUABwAPzmKulavKSWjsBgIAeAnCWkAAClg5HPedeFjxUeCG4AA/gdWV+/7e2kEjrmX+vuZ9eYQQn4f2o8Hvia1biPTeolBUQZaHSPAAAA=",
    "importedAt": "2026-06-07T15:41:46.330Z"
  },
  {
    "id": "ats-compatible-resume-2-6d51b9bd",
    "title": "ATS Compatible Resume",
    "slug": "ats-compatible-resume-2",
    "subtitle": "Professional · ATS Friendly",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/ats-compatible-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/ats-compatible-resume.pdf",
    "googleSlideId": "1R6T20VHAF7pbyDOkp2GSsq82Jg0eAc40UaYU0nj-MGk",
    "copyUrl": "https://docs.google.com/presentation/d/1R6T20VHAF7pbyDOkp2GSsq82Jg0eAc40UaYU0nj-MGk/template/preview",
    "tags": [
      "Professional",
      "ATS Friendly"
    ],
    "atsScore": 99,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to pass ATS screening and impress hiring managers.",
    "overview": "Purpose-built for ATS compatibility, ensuring your resume reaches human reviewers every time. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Purpose-built for ATS - zero formatting elements that could block automated parsing",
      "High ATS score means your resume passes automated screening without formatting interference",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAAAQAwCdASoUABwAPzmUwFmvKaajqAgB4CcJaR9kAAKacAAA/u5tA7p2nsxCnzgKGvUZZ9xOfZT1lkGooxSbOqT6gYbEwAAA",
    "importedAt": "2026-06-07T15:41:52.382Z"
  },
  {
    "id": "ats-compliant-resume-2-edf73701",
    "title": "ATS Compliant Resume",
    "slug": "ats-compliant-resume-2",
    "subtitle": "Professional · ATS Friendly",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/ats-compliant-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/ats-compliant-resume.pdf",
    "googleSlideId": "1Eame3bOd_J-8dbmrnkBlK7DKT-8Vw0JbgJKoof7_yT0",
    "copyUrl": "https://docs.google.com/presentation/d/1Eame3bOd_J-8dbmrnkBlK7DKT-8Vw0JbgJKoof7_yT0/template/preview",
    "tags": [
      "Professional",
      "ATS Friendly"
    ],
    "atsScore": 99,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to pass ATS screening and impress hiring managers.",
    "overview": "Purpose-built for ATS compatibility, ensuring your resume reaches human reviewers every time. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Purpose-built for ATS - zero formatting elements that could block automated parsing",
      "High ATS score means your resume passes automated screening without formatting interference",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAABQAwCdASoUABwAPzmSv1mvKaalKAgB4CcJaR9AAAKELgFgAAD+7pxdzXdqMS0vwjHVK5vLIYVtcQpJ1ZSuUAAA",
    "importedAt": "2026-06-07T15:41:54.316Z"
  },
  {
    "id": "remote-work-resume-2-504af365",
    "title": "Remote Work Resume",
    "slug": "remote-work-resume-2",
    "subtitle": "Professional · Remote Friendly",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/remote-work-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/remote-work-resume.pdf",
    "googleSlideId": "1xFOkS3oakE8VJ5E4vgLbTvurPYJsGccIH36VCP4y1hE",
    "copyUrl": "https://docs.google.com/presentation/d/1xFOkS3oakE8VJ5E4vgLbTvurPYJsGccIH36VCP4y1hE/template/preview",
    "tags": [
      "Professional",
      "Remote Friendly"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Layout optimized for remote-first job listings - highlights independent work capabilities",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAABwAwCdASoUABwAPzmSv1mvKaajqAgB4CcJaQAAPZbUB4uGmAAA/u5fe/4D9EI7ZSPHQPoLz62YAAAA",
    "importedAt": "2026-06-07T15:41:59.241Z"
  },
  {
    "id": "recent-college-graduate-resume-2-82ef8559",
    "title": "Recent College Graduate Resume",
    "slug": "recent-college-graduate-resume-2",
    "subtitle": "Entry Level · Skills Section · Objective",
    "category": "entry-level",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/recent-college-graduate-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/recent-college-graduate-resume.pdf",
    "googleSlideId": "1BYEKrCCC9MG1RIByebvyrxCVEwcojg4gmy1e3OQMiDk",
    "copyUrl": "https://docs.google.com/presentation/d/1BYEKrCCC9MG1RIByebvyrxCVEwcojg4gmy1e3OQMiDk/template/preview",
    "tags": [
      "Entry Level",
      "Skills Section",
      "Objective",
      "Achievements",
      "Multilingual",
      "Publications",
      "Volunteer Work"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for recent graduates and entry-level candidates who want to land their first role with confidence.",
    "overview": "Entry-level optimized structure that compensates for limited work history with strong section design. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Achievements section draws recruiter attention to measurable impact and quantifiable results"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAACQAwCdASoUABwAPzmEu1avJ6WjsBgIAeAnCWlqFAAaDv/M5CkAAP7ukLLUdoKJYE4Ii2sSjAgVMcYCh4HZWDBu9fdHS4AA",
    "importedAt": "2026-06-07T15:42:03.055Z"
  },
  {
    "id": "senior-software-engineer-resume-2-dc8cf45b",
    "title": "Senior Software Engineer Resume",
    "slug": "senior-software-engineer-resume-2",
    "subtitle": "IT & Tech · Senior Level",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/senior-software-engineer-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/senior-software-engineer-resume.pdf",
    "googleSlideId": "1sqGREYY9-bf_G-wHq_NSOlQqcYmfDXaOlO0EtLUhBgo",
    "copyUrl": "https://docs.google.com/presentation/d/1sqGREYY9-bf_G-wHq_NSOlQqcYmfDXaOlO0EtLUhBgo/template/preview",
    "tags": [
      "IT & Tech",
      "Senior Level"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Structure designed to highlight leadership trajectory, strategic roles, and career progression",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAwCdASoUABwAPzmWwlmvKqcjqAgB4CcJaWvbABu5ggAA/u6a7nA+ViPNh0MQgfsG1uQszjwAAAAA",
    "importedAt": "2026-06-07T15:42:08.031Z"
  },
  {
    "id": "clean-modern-resume-2-d8093090",
    "title": "Clean Modern Resume",
    "slug": "clean-modern-resume-2",
    "subtitle": "Professional · Minimal · Modern",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/clean-modern-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/clean-modern-resume.pdf",
    "googleSlideId": "12TESeNJtGfhj36lii8n2E08asA1s_O2g0xF0f8uFR_w",
    "copyUrl": "https://docs.google.com/presentation/d/12TESeNJtGfhj36lii8n2E08asA1s_O2g0xF0f8uFR_w/template/preview",
    "tags": [
      "Professional",
      "Minimal",
      "Modern"
    ],
    "atsScore": 82,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal modern format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The minimal design keeps the focus entirely on your experience and qualifications.",
    "tips": [
      "Minimal design philosophy reduces visual noise - all recruiter attention stays on your content",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlYAAABXRUJQVlA4IEoAAACwAwCdASoUABwAPzmQulgvKaUjqAqp4CcJaQAALtfLH/SExJdNAAD+4Ik7hLUbgJByfOW53nrt9k1sgrqyO0EOPy0MAv9v+lwAAA==",
    "importedAt": "2026-06-07T15:42:10.486Z"
  },
  {
    "id": "faang-resume-2-1239038f",
    "title": "FAANG Resume",
    "slug": "faang-resume-2",
    "subtitle": "IT & Tech",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/faang-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/faang-resume.pdf",
    "googleSlideId": "11s4dWOIvz2l32bqEofc1yqFVIav1ABJrvXGuA_T5L3Y",
    "copyUrl": "https://docs.google.com/presentation/d/11s4dWOIvz2l32bqEofc1yqFVIav1ABJrvXGuA_T5L3Y/template/preview",
    "tags": [
      "IT & Tech"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems",
      "Save and submit as PDF to maintain visual formatting across all devices and platforms"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAADwAgCdASoUABwAPzmQu1ivKaWjqAqp4CcJaQAAPlRrgAD+7mLT6qupfbTPG+DRjlgAAA==",
    "importedAt": "2026-06-07T15:42:18.562Z"
  },
  {
    "id": "mccombs-resume-2-4df0428e",
    "title": "Mccombs Resume",
    "slug": "mccombs-resume-2",
    "subtitle": "Academic",
    "category": "academic",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/mccombs-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/mccombs-resume.pdf",
    "googleSlideId": "1REi7X_G3KQGYwjzE0ZxA8n_Va9JFc16NF7CR1dGYgcE",
    "copyUrl": "https://docs.google.com/presentation/d/1REi7X_G3KQGYwjzE0ZxA8n_Va9JFc16NF7CR1dGYgcE/template/preview",
    "tags": [
      "Academic"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for academics and researchers who want to make a strong, lasting first impression.",
    "overview": "Academic layout structured to highlight research, publications, and scholarly achievements. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Academic CV format accommodates publications, grants, and research - far beyond a standard resume",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAABQAwCdASoUABwAPzmSwFmvKaajqAgB4CcJaQAAPZfhpwqYEAD+7ix/+mFNteluyH1IouMeZ8zW5Qy5ltA8kHK1D2r0AAAA",
    "importedAt": "2026-06-07T15:42:19.529Z"
  },
  {
    "id": "blank-resume-2-a2f158f4",
    "title": "Blank Resume",
    "slug": "blank-resume-2",
    "subtitle": "Professional · Minimal",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/blank-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/blank-resume.pdf",
    "googleSlideId": "1rH0j4_2B-VPD8V7avTMnL2u0EU2vxHhn3kdnWSTJZWc",
    "copyUrl": "https://docs.google.com/presentation/d/1rH0j4_2B-VPD8V7avTMnL2u0EU2vxHhn3kdnWSTJZWc/template/preview",
    "tags": [
      "Professional",
      "Minimal"
    ],
    "atsScore": 78,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The minimal design keeps the focus entirely on your experience and qualifications.",
    "tips": [
      "Minimal design philosophy reduces visual noise - all recruiter attention stays on your content",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAACQAwCdASoUABwAPzmSv1mvKaajqAgB4CcJaQAAPZYhZvDA3JAAAP7ua3r3/Ai7pt9j7yNYt3UtZ8OiTesVywf/AAAAAA==",
    "importedAt": "2026-06-07T15:42:26.792Z"
  },
  {
    "id": "product-manager-resume-2-3abed34b",
    "title": "Product Manager Resume",
    "slug": "product-manager-resume-2",
    "subtitle": "IT & Tech · Functional · Skills Section",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/product-manager-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/product-manager-resume.pdf",
    "googleSlideId": "14urCTO_mblVrvmmhBlIrH7Ri8D11SC_oX1vo83tkclA",
    "copyUrl": "https://docs.google.com/presentation/d/14urCTO_mblVrvmmhBlIrH7Ri8D11SC_oX1vo83tkclA/template/preview",
    "tags": [
      "IT & Tech",
      "Functional",
      "Skills Section",
      "Summary",
      "Certifications",
      "Publications"
    ],
    "atsScore": 77,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a compelling professional summary - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The professional summary section gives recruiters an immediate, compelling overview of your value.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Professional summary gives recruiters a compelling 5-second overview of your career value",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAACwAwCdASoUABwAPzmQwVevKaejqAqp4CcJaQAALnhQYoCwh1XOwAD+4IjpQyoZr/4nZX4Yoa0EqsDSYspgtXP2iqD9sBAA",
    "importedAt": "2026-06-07T15:42:27.094Z"
  },
  {
    "id": "data-analyst-resume-2-92fafc08",
    "title": "Data Analyst Resume",
    "slug": "data-analyst-resume-2",
    "subtitle": "Finance & Business · Skills Section · Certifications",
    "category": "finance",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/data-analyst-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/data-analyst-resume.pdf",
    "googleSlideId": "1xOyXJkiJovMen5iCpTvUfN40xOH7YpwuvpKwPE-2BqY",
    "copyUrl": "https://docs.google.com/presentation/d/1xOyXJkiJovMen5iCpTvUfN40xOH7YpwuvpKwPE-2BqY/template/preview",
    "tags": [
      "Finance",
      "Skills Section",
      "Certifications"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for finance and business professionals who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Finance & Business roles. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADwAgCdASoUABwAPzmOwFevKacjqAqp4CcJaQAAPlQ2AAD+7ik/RYtxytIbSRjStNWrQgfbN7OLPI+NdaONKTKgAAA=",
    "importedAt": "2026-06-07T15:42:35.526Z"
  },
  {
    "id": "registered-nurse-resume-2-cf7a2cc2",
    "title": "Registered Nurse Resume",
    "slug": "registered-nurse-resume-2",
    "subtitle": "Healthcare · Senior Level · Volunteer Work",
    "category": "medical",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/registered-nurse-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/registered-nurse-resume.pdf",
    "googleSlideId": "1DJvvrThBIhUcxoXGZrHOvU1pArBIEyN6XkhFzGJyj-0",
    "copyUrl": "https://docs.google.com/presentation/d/1DJvvrThBIhUcxoXGZrHOvU1pArBIEyN6XkhFzGJyj-0/template/preview",
    "tags": [
      "Healthcare",
      "Senior Level",
      "Volunteer Work"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for healthcare professionals who want to make a strong, lasting first impression.",
    "overview": "Clean clinical format structured to meet the expectations of healthcare recruiters. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Volunteer section adds character and demonstrates community engagement - valued by modern employers",
      "Structure designed to highlight leadership trajectory, strategic roles, and career progression",
      "Clinical format meets the specific expectations of hospital HR systems and healthcare recruiters"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAADwAwCdASoUABwAPzmSulgvKiUjqAqp4CcJaQAAKQ9M5EKXXvq+BQgAAP5oRn236DGCaAlRq2G4vdBHwhUtL8437qF5hEbd+BgrPmR8RB8m1h1WGHIQAAAA",
    "importedAt": "2026-06-07T15:42:37.975Z"
  },
  {
    "id": "tech-resume-2-0fa6977a",
    "title": "Tech Resume",
    "slug": "tech-resume-2",
    "subtitle": "IT & Tech · Skills Section · Projects Section",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/tech-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/tech-resume.pdf",
    "googleSlideId": "12I8OqlbkULITxuRNfZ3hCaks9YQkHLJB3C0S8CBwY6c",
    "copyUrl": "https://docs.google.com/presentation/d/12I8OqlbkULITxuRNfZ3hCaks9YQkHLJB3C0S8CBwY6c/template/preview",
    "tags": [
      "IT & Tech",
      "Skills Section",
      "Projects Section",
      "Achievements"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a dedicated projects section - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Achievements section draws recruiter attention to measurable impact and quantifiable results"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAAAwBACdASoUABwAPzmEu1avJ6WjsBgIAeAnCWkAAD32E1qkSuUTVuuelAAA/u5nfK1guEin4cjqDAZo4cVbcjl+cvQ3kgQA",
    "importedAt": "2026-06-07T15:42:45.429Z"
  },
  {
    "id": "advanced-functional-resume-2-330b3ad5",
    "title": "Advanced Functional Resume",
    "slug": "advanced-functional-resume-2",
    "subtitle": "Professional · Functional · Senior Level",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/advanced-functional-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/advanced-functional-resume.pdf",
    "googleSlideId": "1o9DF-f65yD58MXMy1l1nBRP7YL_e-k1wNl2kbFvlgUY",
    "copyUrl": "https://docs.google.com/presentation/d/1o9DF-f65yD58MXMy1l1nBRP7YL_e-k1wNl2kbFvlgUY/template/preview",
    "tags": [
      "Professional",
      "Functional",
      "Senior Level"
    ],
    "atsScore": 77,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured functional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Skills-focused functional format that highlights competencies over job history. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Structure designed to highlight leadership trajectory, strategic roles, and career progression",
      "Functional format is highly effective for career changers and skill-first professionals",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAABQBACdASoUABwAPzmMulYvKSWjsBgIAeAnCWkAAC7QjeSbwugxdS1hC5mgAP7fHVD1pUGwThXCGYVw9ODyIWhGp0PFgxGOs2kRZxAAAAA=",
    "importedAt": "2026-06-07T15:42:47.024Z"
  },
  {
    "id": "undergrad-resume-2-fa639958",
    "title": "Undergrad Resume",
    "slug": "undergrad-resume-2",
    "subtitle": "Professional · Skills Section · Projects Section",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/undergrad-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/undergrad-resume.pdf",
    "googleSlideId": "1w0tUxxoK5p0Vr5Ql3MmLOl4B0Wcqb5TCHyBN-V9GDCs",
    "copyUrl": "https://docs.google.com/presentation/d/1w0tUxxoK5p0Vr5Ql3MmLOl4B0Wcqb5TCHyBN-V9GDCs/template/preview",
    "tags": [
      "Professional",
      "Skills Section",
      "Projects Section",
      "Objective"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Optimized for recent graduates - structure compensates for limited professional work history"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAABQAwCdASoUABwAPzmQvVgvKaYjqAqp4CcJaQAAPk/6RlRLoAD+7jcJIV8Qzx9nwPMnEH9C8Lk6ayyXwtD+LcC8AAA=",
    "importedAt": "2026-06-07T15:42:54.262Z"
  },
  {
    "id": "traditional-resume-2-3ddbaff1",
    "title": "Traditional Resume",
    "slug": "traditional-resume-2",
    "subtitle": "Professional · Minimal · Skills Section",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/traditional-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/traditional-resume.pdf",
    "googleSlideId": "1n96laegifkIn-6CJANEGTSqS44wA3Pmv62qK0O7UdUg",
    "copyUrl": "https://docs.google.com/presentation/d/1n96laegifkIn-6CJANEGTSqS44wA3Pmv62qK0O7UdUg/template/preview",
    "tags": [
      "Professional",
      "Minimal",
      "Skills Section",
      "Projects Section",
      "Certifications",
      "Achievements"
    ],
    "atsScore": 89,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal traditional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Traditional structure trusted by hiring managers across all Professional roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Traditional format is universally accepted across all major ATS systems globally",
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAAAQAwCdASoUABwAPzmMvFYvKSYjsBgIAeAnCWkAAD46vgAA/u42cNHKCnpp/ov6fl8R1SMYOEAtsoSzOg7dEZiZoXo0FdAAAAA=",
    "importedAt": "2026-06-07T15:43:01.160Z"
  },
  {
    "id": "swe-resume-2-711a573d",
    "title": "SWE Resume",
    "slug": "swe-resume-2",
    "subtitle": "IT & Tech",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/swe-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/swe-resume.pdf",
    "googleSlideId": "1sMAnJpqGkgJHPxlMojCWf1qTBf3vZjyRnAUOCAi2ojc",
    "copyUrl": "https://docs.google.com/presentation/d/1sMAnJpqGkgJHPxlMojCWf1qTBf3vZjyRnAUOCAi2ojc/template/preview",
    "tags": [
      "IT & Tech"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems",
      "Save and submit as PDF to maintain visual formatting across all devices and platforms"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAADQAwCdASoUABwAPy2EtFOuqSUit/VYAdAliWcAzFgRD2dWCC+m/AAA/udTk4jtOINDNUzyxnUsH8HEyuuWWrXnJ+lFH9NlfaKlvgAA",
    "importedAt": "2026-06-07T15:43:06.944Z"
  },
  {
    "id": "resume-with-photo-2-434890a8",
    "title": "Resume with Photo",
    "slug": "resume-with-photo-2",
    "subtitle": "Professional · With Photo · Certifications",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/resume-with-photo.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/resume-with-photo.pdf",
    "googleSlideId": "1abeXc1afmLCrvLw2yzR4_OaT71YxbCznN2BEIMUvg0w",
    "copyUrl": "https://docs.google.com/presentation/d/1abeXc1afmLCrvLw2yzR4_OaT71YxbCznN2BEIMUvg0w/template/preview",
    "tags": [
      "Professional",
      "With Photo",
      "Certifications"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with an integrated photo section - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The integrated photo section adds a personal dimension, ideal for client-facing and creative roles.",
    "tips": [
      "Professional photo section adds a personal dimension - ideal for client-facing and international roles",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmAAAABXRUJQVlA4IFQAAACQAwCdASoUABwAPzmQvFWvKqYjMBgIAeAnCWkAAB7q6R7GWYAAAP5JP43AQ0mn91KvhGOm2wee3iDotfX+LW849JnTAoF4t3bmvm5w8QfXWQAAAAA=",
    "importedAt": "2026-06-07T15:43:16.516Z"
  },
  {
    "id": "harvard-college-resume-2-9f7ef210",
    "title": "Harvard College Resume",
    "slug": "harvard-college-resume-2",
    "subtitle": "Academic · Skills Section · Projects Section",
    "category": "academic",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/harvard-college-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/harvard-college-resume.pdf",
    "googleSlideId": "1bNIXjN04-bY_qD5lKnyCgFMiKjj0VAF6IePd9213um4",
    "copyUrl": "https://docs.google.com/presentation/d/1bNIXjN04-bY_qD5lKnyCgFMiKjj0VAF6IePd9213um4/template/preview",
    "tags": [
      "Academic",
      "Skills Section",
      "Projects Section",
      "Summary",
      "Publications",
      "Volunteer Work"
    ],
    "atsScore": 77,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a compelling professional summary - ideal for academics and researchers who want to make a strong, lasting first impression.",
    "overview": "Academic layout structured to highlight research, publications, and scholarly achievements. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Professional summary gives recruiters a compelling 5-second overview of your career value"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAABwBACdASoUABwAPzmIvFSvKSYjKA1R4CcJaQAALmli2XguubQtYInjr05AAAD9yzQuX+cgIzpS5z7Ie1b7eVwc5tdb/RaFESpFeFJ76E5i24ttmssS1+g7F7FgMAAA",
    "importedAt": "2026-06-07T15:43:21.040Z"
  },
  {
    "id": "interior-designer-resume-2-7405c5b9",
    "title": "Interior Designer Resume",
    "slug": "interior-designer-resume-2",
    "subtitle": "Creative & Design · Creative Layout · With Photo",
    "category": "creative",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/interior-designer-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/interior-designer-resume.pdf",
    "googleSlideId": "1Fqe94tH_XDVXCze1Q7P9jAw3Mu1A4Tjx1HrItjevb-8",
    "copyUrl": "https://docs.google.com/presentation/d/1Fqe94tH_XDVXCze1Q7P9jAw3Mu1A4Tjx1HrItjevb-8/template/preview",
    "tags": [
      "Creative & Design",
      "Creative Layout",
      "With Photo",
      "Skills Section",
      "Projects Section",
      "Multilingual"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with an integrated photo section - ideal for creative professionals and designers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Creative & Design applicant pools. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmIAAABXRUJQVlA4IFYAAABQBACdASoUABwAPzmGu1OvKSaisBgMAeAnCWcAAC50+PpaPZDCIxDsygQAAP7V56E0n9Tl5Dcn7Ne35ifXgb5TfLiKDievE12ueHDaadFQIf5V1/gQAA==",
    "importedAt": "2026-06-07T15:43:30.464Z"
  },
  {
    "id": "teacher-resume-2-79e3fdea",
    "title": "Teacher Resume",
    "slug": "teacher-resume-2",
    "subtitle": "Professional · Skills Section · Multilingual",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/teacher-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/teacher-resume.pdf",
    "googleSlideId": "1ExD4QHdzLqTGlICWXTQv5zgmKK8X6xWP21j260CtH1w",
    "copyUrl": "https://docs.google.com/presentation/d/1ExD4QHdzLqTGlICWXTQv5zgmKK8X6xWP21j260CtH1w/template/preview",
    "tags": [
      "Professional",
      "Skills Section",
      "Multilingual"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAADwBACdASoUABwAPzV+t1OvJ6Uit/VYAeAmiUAZC4IelYNwLP7OpA2nyrvw56bapAAA/t6Z/ErycaCzSk4k5SemjjApWBwxzL8OHA/5GQw/RL7GkR2Ym8MBvyTvJyQYW6tVACmpr8Vt5aQ5AXNmAFsGh6ejFzLnF0Vrx4ANeqAAAA==",
    "importedAt": "2026-06-07T15:43:31.432Z"
  },
  {
    "id": "chronological-resume-2-a4e149cd",
    "title": "Chronological Resume",
    "slug": "chronological-resume-2",
    "subtitle": "Professional · Chronological",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/chronological-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/chronological-resume.pdf",
    "googleSlideId": "1c4oc3WJ6rswh2T04-AcCB6c-po_hDVFl15MSoCu_T7U",
    "copyUrl": "https://docs.google.com/presentation/d/1c4oc3WJ6rswh2T04-AcCB6c-po_hDVFl15MSoCu_T7U/template/preview",
    "tags": [
      "Professional",
      "Chronological"
    ],
    "atsScore": 85,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A structured, chronological chronological format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Chronological format that clearly communicates career progression and growth over time. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Chronological format is preferred by 90%+ of recruiters for clearly showing career progression",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAABwAwCdASoUABwAPzmEvVavL6YjsBgIAfAnCWkAACnTYv7H9AAA/o04oFDa3yZ+B054QAAA",
    "importedAt": "2026-06-07T15:43:38.321Z"
  },
  {
    "id": "internship-resume-2-83449bfd",
    "title": "Internship Resume",
    "slug": "internship-resume-2",
    "subtitle": "Entry Level · Projects Section",
    "category": "entry-level",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/internship-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/internship-resume.pdf",
    "googleSlideId": "14yKgc4ubTJFSks2E49X7odxuEvVP4zXVALzNpwstSHU",
    "copyUrl": "https://docs.google.com/presentation/d/14yKgc4ubTJFSks2E49X7odxuEvVP4zXVALzNpwstSHU/template/preview",
    "tags": [
      "Entry Level",
      "Projects Section"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a dedicated projects section - ideal for recent graduates and entry-level candidates who want to land their first role with confidence.",
    "overview": "Entry-level optimized structure that compensates for limited work history with strong section design. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Optimized for recent graduates - structure compensates for limited professional work history",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAABwAwCdASoUABwAPzmUwlmvKicjqAgB4CcJaWhNABto3/m25IAA/u5ZdjR+x9ftHMEYxookTVqKrMzhQdq6AAAA",
    "importedAt": "2026-06-07T15:43:40.165Z"
  },
  {
    "id": "customizable-resume-2-23e9a340",
    "title": "Customizable Resume",
    "slug": "customizable-resume-2",
    "subtitle": "Professional",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/customizable-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/customizable-resume.pdf",
    "googleSlideId": "1tZzhQKzlTrXkYT1VUJ0gxGQeRbW8KQ2zQ2ovOa2wqLs",
    "copyUrl": "https://docs.google.com/presentation/d/1tZzhQKzlTrXkYT1VUJ0gxGQeRbW8KQ2zQ2ovOa2wqLs/template/preview",
    "tags": [
      "Professional"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems",
      "Save and submit as PDF to maintain visual formatting across all devices and platforms"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAADwAwCdASoUABwAPzmQvFUvKqYjMBgIAeAnCWkAAC+t3qXzevwo68gAAP7nIZZOVaNp7XQxNodya2gHr3lEApSyrI1YM38RQv9MpbgAAAA=",
    "importedAt": "2026-06-07T15:43:47.528Z"
  },
  {
    "id": "green-resume-2-ecc4ff0e",
    "title": "Green Resume",
    "slug": "green-resume-2",
    "subtitle": "Professional · Creative Layout · Skills Section",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/green-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/green-resume.pdf",
    "googleSlideId": "1PW0y7lP8_1hLtDbGDh3dv99sWtSylfuiQ5Hl9yaTfM0",
    "copyUrl": "https://docs.google.com/presentation/d/1PW0y7lP8_1hLtDbGDh3dv99sWtSylfuiQ5Hl9yaTfM0/template/preview",
    "tags": [
      "Professional",
      "Creative Layout",
      "Skills Section",
      "Achievements",
      "Volunteer Work"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with a unique visual layout - ideal for professionals across all industries who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Professional applicant pools. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Unique visual layout helps you immediately stand out in competitive creative applicant pools",
      "Achievements section draws recruiter attention to measurable impact and quantifiable results"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAAAwAwCdASoUABwAPzmUwFmvKialKAgB4CcJZ2ssWmSJzHIAAP7nN42mcjupnw9p7yE5i7HZX2GGUTC+Mj2R4lAAAAA=",
    "importedAt": "2026-06-07T15:43:47.899Z"
  },
  {
    "id": "executive-resume-2-76e6abe0",
    "title": "Executive Resume",
    "slug": "executive-resume-2",
    "subtitle": "Executive",
    "category": "executive",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/executive-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/executive-resume.pdf",
    "googleSlideId": "1NcAnWsthcMh5mfoLMmnPaADOxA9qqKoXRwepvgL4B8Y",
    "copyUrl": "https://docs.google.com/presentation/d/1NcAnWsthcMh5mfoLMmnPaADOxA9qqKoXRwepvgL4B8Y/template/preview",
    "tags": [
      "Executive"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for senior executives and C-suite professionals who want to command attention at the executive level.",
    "overview": "Executive-grade layout designed to reflect authority, leadership, and strategic impact. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Executive format commands respect - clean hierarchy reflects leadership and strategic thinking",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAABQAwCdASoUABwAPzGAs1OuqCSisAwB0CYJZwAAW9hUf+lC4AD+6nSsx1BWYepwLtwMzb7B1D65Dg9Egc3hk6UmFJ1WMgAA",
    "importedAt": "2026-06-07T15:43:57.160Z"
  },
  {
    "id": "freelance-resume-2-915c90f8",
    "title": "Freelance Resume",
    "slug": "freelance-resume-2",
    "subtitle": "Marketing & Sales · Skills Section · Summary",
    "category": "marketing",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/freelance-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/freelance-resume.pdf",
    "googleSlideId": "1l6Iw2OmAsHWhLG5lceJvYA7D710iv1ACAvjD4i0vg1A",
    "copyUrl": "https://docs.google.com/presentation/d/1l6Iw2OmAsHWhLG5lceJvYA7D710iv1ACAvjD4i0vg1A/template/preview",
    "tags": [
      "Marketing",
      "Skills Section",
      "Summary"
    ],
    "atsScore": 77,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a compelling professional summary - ideal for marketing and sales professionals who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Marketing & Sales roles. The professional summary section gives recruiters an immediate, compelling overview of your value.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Professional summary gives recruiters a compelling 5-second overview of your career value",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmIAAABXRUJQVlA4IFYAAAAwBACdASoUABwAPzl8vVOvJyaisBgMAeAnCWkAABWu7vLv03xolT1p2gAA/ngEaHjGUv09N5TytTGErbKlcO6UOxDSE9BodNUokph9R+zTmdC/7uAAAA==",
    "importedAt": "2026-06-07T15:43:59.279Z"
  },
  {
    "id": "architects-resume-2-26f18c2d",
    "title": "Architect's Resume",
    "slug": "architects-resume-2",
    "subtitle": "Creative & Design · Creative Layout · With Photo",
    "category": "creative",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/architects-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/architects-resume.pdf",
    "googleSlideId": "11jvczMUDHzNepxGGQjrlBPqpzIrV_VMaPOv6M-7X53A",
    "copyUrl": "https://docs.google.com/presentation/d/11jvczMUDHzNepxGGQjrlBPqpzIrV_VMaPOv6M-7X53A/template/preview",
    "tags": [
      "Creative & Design",
      "Creative Layout",
      "With Photo",
      "Skills Section",
      "Summary",
      "Multilingual"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with an integrated photo section - ideal for creative professionals and designers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Creative & Design applicant pools. The integrated photo section adds a personal dimension, ideal for client-facing and creative roles.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Professional photo section adds a personal dimension - ideal for client-facing and international roles"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRngAAABXRUJQVlA4IGwAAABwBACdASoUABwAPzmMulYvKSWjqA1R4CcJZQDMWBEdrBtB96yfYw3cc6TsQAD8juqBjKSG5buUAhiz6CkHbEOcvz25NKrOODsIvdrdprwNLDKUW3FgySRQ5/n9jXj7fdIHZnBy7gquLYQAAAA=",
    "importedAt": "2026-06-07T15:44:10.589Z"
  },
  {
    "id": "creative-resume-2-416cdd57",
    "title": "Creative Resume",
    "slug": "creative-resume-2",
    "subtitle": "IT & Tech · Creative Layout · Skills Section",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/creative-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/creative-resume.pdf",
    "googleSlideId": "1Uy_lxfk-gI16_S53nJe969qqo_B-sG81-heSd31TdsE",
    "copyUrl": "https://docs.google.com/presentation/d/1Uy_lxfk-gI16_S53nJe969qqo_B-sG81-heSd31TdsE/template/preview",
    "tags": [
      "IT & Tech",
      "Creative Layout",
      "Skills Section",
      "Summary",
      "Multilingual"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking creative format with a compelling professional summary - ideal for IT professionals and developers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive IT & Tech applicant pools. The professional summary section gives recruiters an immediate, compelling overview of your value.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Unique visual layout helps you immediately stand out in competitive creative applicant pools"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAAAQBACdASoUABwAPzmOwFevKacjqAqp4CcJYwBUQoPS8GF+a9Spq/IsgAD+3x1kJ55VXGXV6LiaHESzTbMvE/j+FEy+niNcryxEfyQlre/QUrQW4ln91U30Axul28d0F0iFTSxbMoAAAA==",
    "importedAt": "2026-06-07T15:44:15.159Z"
  },
  {
    "id": "nursing-resume-2-fcbfb3f8",
    "title": "Nursing Resume",
    "slug": "nursing-resume-2",
    "subtitle": "Healthcare · Senior Level · Skills Section",
    "category": "medical",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/nursing-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/nursing-resume.pdf",
    "googleSlideId": "1G93ysnqJv2s54z7eB8UZqegrMfJrxDCEj5UEh2eSc3o",
    "copyUrl": "https://docs.google.com/presentation/d/1G93ysnqJv2s54z7eB8UZqegrMfJrxDCEj5UEh2eSc3o/template/preview",
    "tags": [
      "Healthcare",
      "Senior Level",
      "Skills Section",
      "Summary",
      "Certifications",
      "References"
    ],
    "atsScore": 77,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a compelling professional summary - ideal for healthcare professionals who want to make a strong, lasting first impression.",
    "overview": "Clean clinical format structured to meet the expectations of healthcare recruiters. The professional summary section gives recruiters an immediate, compelling overview of your value.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Professional summary gives recruiters a compelling 5-second overview of your career value",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAADwAgCdASoUABwAPzmQvlevKaYjqAqp4CcJaQAAPlQ2AAD+7mfOPgA9XLJJHnP8h364UE7zr0UgAAAA",
    "importedAt": "2026-06-07T15:44:22.631Z"
  },
  {
    "id": "graphic-designer-resume-2-236a67e9",
    "title": "Graphic Designer Resume",
    "slug": "graphic-designer-resume-2",
    "subtitle": "Creative & Design · Creative Layout · Skills Section",
    "category": "creative",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/graphic-designer-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/graphic-designer-resume.pdf",
    "googleSlideId": "1UGGWjXCRTK5Q9BPpIW2jrmhWMmEACHDgX7rc6Hicyio",
    "copyUrl": "https://docs.google.com/presentation/d/1UGGWjXCRTK5Q9BPpIW2jrmhWMmEACHDgX7rc6Hicyio/template/preview",
    "tags": [
      "Creative & Design",
      "Creative Layout",
      "Skills Section",
      "Summary",
      "Achievements",
      "Multilingual"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with a compelling professional summary - ideal for creative professionals and designers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Creative & Design applicant pools. The professional summary section gives recruiters an immediate, compelling overview of your value.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Unique visual layout helps you immediately stand out in competitive creative applicant pools"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAACwBACdASoUABwAPzmOulWvKiWjMBgIAeAnCWMAy6QNtSI3IYYoHbC4a5i7P32wAPae0hh8CQr2P0X4adsyhoxhd/zKa0bQ2fWAaPqJslZiJYd9wRt2TejWIUo/CUscOz3sZCxm+fUiNGhdR18xm6u/jauXod7shsmgH1Wra2WFPxTnJeEr+UrfBKXgAA==",
    "importedAt": "2026-06-07T15:44:34.208Z"
  },
  {
    "id": "physician-assistant-resume-2-026046de",
    "title": "Physician Assistant Resume",
    "slug": "physician-assistant-resume-2",
    "subtitle": "Healthcare · Certifications · Achievements",
    "category": "medical",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/physician-assistant-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/physician-assistant-resume.pdf",
    "googleSlideId": "1UD6unB6QpRBZaHc-yKyc71sjVM9jWAobFcpTcYMiiPk",
    "copyUrl": "https://docs.google.com/presentation/d/1UD6unB6QpRBZaHc-yKyc71sjVM9jWAobFcpTcYMiiPk/template/preview",
    "tags": [
      "Healthcare",
      "Certifications",
      "Achievements"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for healthcare professionals who want to make a strong, lasting first impression.",
    "overview": "Clean clinical format structured to meet the expectations of healthcare recruiters. Dedicated certifications space ensures professional credentials are prominently displayed.",
    "tips": [
      "Dedicated certifications section ensures professional credentials get the visibility they deserve",
      "Achievements section draws recruiter attention to measurable impact and quantifiable results",
      "Clinical format meets the specific expectations of hospital HR systems and healthcare recruiters"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAACwAwCdASoUABwAPzmIuFOvKSUisAgB4CcJZwAATvzj23P5jxroAAD+vYZlSvzQhAr34VnXHYwYNcopVPf1yQsocu5NgBG+JXFv9KTGm1sKRGTAlI4qiTEuiNsEK8ZAAAA=",
    "importedAt": "2026-06-07T15:44:43.327Z"
  },
  {
    "id": "artist-resume-2-5bd25ed1",
    "title": "Artist Resume",
    "slug": "artist-resume-2",
    "subtitle": "Creative & Design · Creative Layout · With Photo",
    "category": "creative",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/artist-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/artist-resume.pdf",
    "googleSlideId": "1XOudIkFjQt5MJJx8d0KJUeW_pPVZ2w4XDSTnrD3qpp4",
    "copyUrl": "https://docs.google.com/presentation/d/1XOudIkFjQt5MJJx8d0KJUeW_pPVZ2w4XDSTnrD3qpp4/template/preview",
    "tags": [
      "Creative & Design",
      "Creative Layout",
      "With Photo",
      "Skills Section",
      "Projects Section",
      "Publications"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with an integrated photo section - ideal for creative professionals and designers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Creative & Design applicant pools. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Professional photo section adds a personal dimension - ideal for client-facing and international roles"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADwAwCdASoUABwAPzmGvVQvKKajKA1R4CcJZwDL4A0ke8+dSkVSjY4AAP6e7OWDszHzmyfPbbbTxLDeogHhpSqDhEYRbd5saTKADjCw5Us00ACJvKbL82r3B/8btIIfJ/FU6umkM4AAAA==",
    "importedAt": "2026-06-07T15:44:45.993Z"
  },
  {
    "id": "interior-designer-resume-4-94aa7964",
    "title": "Interior Designer Resume",
    "slug": "interior-designer-resume-4",
    "subtitle": "Creative & Design · Creative Layout · With Photo",
    "category": "creative",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/interior-designer-resume-3.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/interior-designer-resume-3.pdf",
    "googleSlideId": "117y7PpHbvP5flPp3m6PhAyuGqZ8AKpnZ9sD7HvmPNvE",
    "copyUrl": "https://docs.google.com/presentation/d/117y7PpHbvP5flPp3m6PhAyuGqZ8AKpnZ9sD7HvmPNvE/template/preview",
    "tags": [
      "Creative & Design",
      "Creative Layout",
      "With Photo",
      "Skills Section",
      "Projects Section",
      "Multilingual"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with an integrated photo section - ideal for creative professionals and designers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Creative & Design applicant pools. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmIAAABXRUJQVlA4IFYAAABQBACdASoUABwAPzmGu1OvKSaisBgMAeAnCWcAAC50+PpaPZDCIxDsygQAAP7V56E0n9Tl5Dcn7Ne35ifXgb5TfLiKDievE12ueHDaadFQIf5V1/gQAA==",
    "importedAt": "2026-06-07T15:44:54.147Z"
  },
  {
    "id": "part-time-job-resume-2-7165bebe",
    "title": "Part-Time Job Resume",
    "slug": "part-time-job-resume-2",
    "subtitle": "Entry Level · Creative Layout · Skills Section",
    "category": "entry-level",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/part-time-job-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/part-time-job-resume.pdf",
    "googleSlideId": "159aoehRELIElkdCuWJt1wdnCMHkUimPPFn9ErCPRyWs",
    "copyUrl": "https://docs.google.com/presentation/d/159aoehRELIElkdCuWJt1wdnCMHkUimPPFn9ErCPRyWs/template/preview",
    "tags": [
      "Entry Level",
      "Creative Layout",
      "Skills Section",
      "Projects Section"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with a dedicated projects section - ideal for recent graduates and entry-level candidates who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Entry Level applicant pools. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Unique visual layout helps you immediately stand out in competitive creative applicant pools"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRqYAAABXRUJQVlA4IJoAAADwBACdASoUABwAPzmKulQvKaWjMAgB4CcJZwAJEAHSn0CCKPSiMsgXNrZa4BGJW3AA/rHniAyUvxQ994vp705YXKdBnp0b0Qvy4iBvc/CzTub2X+yJwM7sRScdFh7rFCKbBIzrIdH14nTLwXfjjvZoeZFo+1MJpMI3CXOUHMM8YOktgb5T+FaHYeFdDkOUKzPytPzFfz7rAAAA",
    "importedAt": "2026-06-07T15:45:02.157Z"
  },
  {
    "id": "simple-geometric-resume-2-6e30eea3",
    "title": "Simple Geometric Resume",
    "slug": "simple-geometric-resume-2",
    "subtitle": "Professional · Minimal",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/simple-geometric-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/simple-geometric-resume.pdf",
    "googleSlideId": "1Y_kuCgPWcTTaVeVALlj6pC30f91tBlSZ5NxsMwj7dsY",
    "copyUrl": "https://docs.google.com/presentation/d/1Y_kuCgPWcTTaVeVALlj6pC30f91tBlSZ5NxsMwj7dsY/template/preview",
    "tags": [
      "Professional",
      "Minimal"
    ],
    "atsScore": 83,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The minimal design keeps the focus entirely on your experience and qualifications.",
    "tips": [
      "Traditional format is universally accepted across all major ATS systems globally",
      "Minimal design philosophy reduces visual noise - all recruiter attention stays on your content",
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRoQAAABXRUJQVlA4IHgAAAAwBACdASoUABwAPzmOv1evKaajqAqp4CcJQAAEsvrVHUDv4NXGwWOysBAA8DPsKGBzCy2IyqhOIn9oVCqukR2s46T6tGY71rv/LvPTKyViZDeWltarcXrdJgBQgC5bRViiYrytK/3DhbbNdv/9f5SITmcmhmIEAAA=",
    "importedAt": "2026-06-07T15:45:02.492Z"
  },
  {
    "id": "theatre-resume-2-07da7619",
    "title": "Theatre Resume",
    "slug": "theatre-resume-2",
    "subtitle": "Creative & Design · Modern · Creative Layout",
    "category": "creative",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/theatre-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/theatre-resume.pdf",
    "googleSlideId": "1ZRE4-DouAgAtDajcWGzJztRgtlv2F5nT7ydoK_T422k",
    "copyUrl": "https://docs.google.com/presentation/d/1ZRE4-DouAgAtDajcWGzJztRgtlv2F5nT7ydoK_T422k/template/preview",
    "tags": [
      "Creative & Design",
      "Modern",
      "Creative Layout",
      "Volunteer Work"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking modern format with a unique visual layout - ideal for creative professionals and designers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Creative & Design applicant pools. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Unique visual layout helps you immediately stand out in competitive creative applicant pools",
      "Volunteer section adds character and demonstrates community engagement - valued by modern employers",
      "Optimized for recent graduates - structure compensates for limited professional work history"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAAAwBACdASoUABwAPzmIu1YvKKYjsBgIAeAnCWkAAC3P3EwdPxA8PDcVwAAA/geBTkdLsqywIoVIx2L6DJl0LjJ0SjHEI7V4zwxI6UeNdv+858c9jk33hi8Uhu6YAAAA",
    "importedAt": "2026-06-07T15:45:12.215Z"
  },
  {
    "id": "office-assistant-resume-2-91712a7f",
    "title": "Office Assistant Resume",
    "slug": "office-assistant-resume-2",
    "subtitle": "Professional · References",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/office-assistant-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/office-assistant-resume.pdf",
    "googleSlideId": "13CJ4VjE2Zb3Q9Q4ZqQe0oCNUUdscwK3b1GK1nILeIXQ",
    "copyUrl": "https://docs.google.com/presentation/d/13CJ4VjE2Zb3Q9Q4ZqQe0oCNUUdscwK3b1GK1nILeIXQ/template/preview",
    "tags": [
      "Professional",
      "References"
    ],
    "atsScore": 73,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The clean structure ensures readability across both digital and print formats.",
    "tips": [
      "Use a standard font like Calibri, Arial, or Garamond for maximum ATS compatibility",
      "Keep margins between 0.5–1 inch to ensure the layout is preserved across all systems",
      "Save and submit as PDF to maintain visual formatting across all devices and platforms"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmgAAABXRUJQVlA4IFwAAACQAwCdASoUABwAPzmOwFcvKacjqAqp4CcJZWd7JaXCNI7sInAAAP7t/2AQQTrUVpsAu+RYo0dBSCm+aRI93mptirMmjf6x13NZe6eaRUfcaTLUryeapgs5iAAAAA==",
    "importedAt": "2026-06-07T15:45:18.182Z"
  },
  {
    "id": "dental-assistant-resume-2-61140dcc",
    "title": "Dental Assistant Resume",
    "slug": "dental-assistant-resume-2",
    "subtitle": "Healthcare · Skills Section · Objective",
    "category": "medical",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/dental-assistant-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/dental-assistant-resume.pdf",
    "googleSlideId": "1-z02cMJCbn4aBhmF3Azwin8Pse5sqdLm8gx7-z_BjQY",
    "copyUrl": "https://docs.google.com/presentation/d/1-z02cMJCbn4aBhmF3Azwin8Pse5sqdLm8gx7-z_BjQY/template/preview",
    "tags": [
      "Healthcare",
      "Skills Section",
      "Objective",
      "Certifications"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for healthcare professionals who want to make a strong, lasting first impression.",
    "overview": "Clean clinical format structured to meet the expectations of healthcare recruiters. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve",
      "Clinical format meets the specific expectations of hospital HR systems and healthcare recruiters"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRoIAAABXRUJQVlA4IHYAAABwBACdASoUABwAPy2AuVOuqKYisAwB0CWJZgDB506tv8B0q0spiNTYd4AMAAD+6nW/iqW8x22amyGBdZBum4vwsv4EB4u1qe/ZN54SGzMDJmedKCXSf0a8/Z6zsgwQfRvwhJ0S0+L6IhFAam0tcYyYygbkHoAA",
    "importedAt": "2026-06-07T15:45:21.248Z"
  },
  {
    "id": "resume-for-programmers-2-480211f5",
    "title": "Resume for Programmers",
    "slug": "resume-for-programmers-2",
    "subtitle": "IT & Tech · Senior Level · Skills Section",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/resume-for-programmers.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/resume-for-programmers.pdf",
    "googleSlideId": "1iIYoP3MOO27B0raj0xEPtv4tRUPN1LmaLaLJWfnB25k",
    "copyUrl": "https://docs.google.com/presentation/d/1iIYoP3MOO27B0raj0xEPtv4tRUPN1LmaLaLJWfnB25k/template/preview",
    "tags": [
      "IT & Tech",
      "Senior Level",
      "Skills Section",
      "Projects Section",
      "Achievements"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a dedicated projects section - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Achievements section draws recruiter attention to measurable impact and quantifiable results"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAAAQAwCdASoUABwAPzmQvVgvKaYjqAqp4CcJaWuVABwILUAA/u5rTQAKHA2rS3dunXMp0tYAAAA=",
    "importedAt": "2026-06-07T15:45:27.889Z"
  },
  {
    "id": "law-school-resume-2-edda011d",
    "title": "Law School Resume",
    "slug": "law-school-resume-2",
    "subtitle": "Academic · Skills Section · Projects Section",
    "category": "academic",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/law-school-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/law-school-resume.pdf",
    "googleSlideId": "15pGQ6wilbVe8FRRfmiPBqYg8hiaeMU_4KUkEIdQlEEE",
    "copyUrl": "https://docs.google.com/presentation/d/15pGQ6wilbVe8FRRfmiPBqYg8hiaeMU_4KUkEIdQlEEE/template/preview",
    "tags": [
      "Academic",
      "Skills Section",
      "Projects Section"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for academics and researchers who want to make a strong, lasting first impression.",
    "overview": "Academic layout structured to highlight research, publications, and scholarly achievements. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Optimized for recent graduates - structure compensates for limited professional work history"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlYAAABXRUJQVlA4IEoAAADQAwCdASoUABwAPzmKt1OvKiUisBgMAeAnCWkAADzYlUUGT+0m2AAA/u4BRNM7rXLgdZ7ehQU5hMherRJcFq94ILaZja+2JbgAAA==",
    "importedAt": "2026-06-07T15:45:37.891Z"
  },
  {
    "id": "business-resume-2-ca2d774b",
    "title": "Business Resume",
    "slug": "business-resume-2",
    "subtitle": "Professional · Skills Section · Summary",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/business-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/business-resume.pdf",
    "googleSlideId": "1UIALEgj7s0BSUmeGOBcd5cdAMxzcLf4ytVFun9m4aTg",
    "copyUrl": "https://docs.google.com/document/d/1UIALEgj7s0BSUmeGOBcd5cdAMxzcLf4ytVFun9m4aTg/template/preview",
    "tags": [
      "Professional",
      "Skills Section",
      "Summary",
      "Publications"
    ],
    "atsScore": 77,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a compelling professional summary - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The professional summary section gives recruiters an immediate, compelling overview of your value.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Professional summary gives recruiters a compelling 5-second overview of your career value",
      "Publications section adds academic credibility - particularly valuable in research and academia"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAACQAwCdASoUABwAPzmUwFovKiakKAgB4CcJaQAALk8H/F+W2BhAAP7fHVD3APih20K6gWOSg864vgI9MEFrGs4BzAAAAA==",
    "importedAt": "2026-06-07T16:15:10.641Z"
  },
  {
    "id": "engineering-resume-22131-2-3652c815",
    "title": "Engineering Resume #22131",
    "slug": "engineering-resume-22131-2",
    "subtitle": "IT & Tech · Functional · Senior Level",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/engineering-resume-22131.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/engineering-resume-22131.pdf",
    "googleSlideId": "1yL8xPZmuTvCnSKnZSLkyOTU-RJyXrappFYTAy2twi9s",
    "copyUrl": "https://docs.google.com/document/d/1yL8xPZmuTvCnSKnZSLkyOTU-RJyXrappFYTAy2twi9s/template/preview",
    "tags": [
      "IT & Tech",
      "Functional",
      "Senior Level",
      "Skills Section",
      "Projects Section"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a dedicated projects section - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Structure designed to highlight leadership trajectory, strategic roles, and career progression"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAAAwBACdASoUABwAPzmMu1YvKSWjsBgIAeAnCWkAADF7mydXq/y0pSw+52gA/sciZFOZ8mdw21kxR5yw7zCC1bE+cPJ2qk5fRg8AAAAA",
    "importedAt": "2026-06-07T16:15:12.331Z"
  },
  {
    "id": "general-resume-2-66f6b3f2",
    "title": "General Resume",
    "slug": "general-resume-2",
    "subtitle": "Professional · Minimal · Skills Section",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/general-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/general-resume.pdf",
    "googleSlideId": "10D6SylDjb1LWkn04qpUXJgDVWqbHLZMdV62urDDUP68",
    "copyUrl": "https://docs.google.com/document/d/10D6SylDjb1LWkn04qpUXJgDVWqbHLZMdV62urDDUP68/template/preview",
    "tags": [
      "Professional",
      "Minimal",
      "Skills Section",
      "Certifications",
      "References"
    ],
    "atsScore": 80,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve",
      "Optimized for recent graduates - structure compensates for limited professional work history"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAADwAgCdASoUABwAPzmWwlmvKqcjqAgB4CcJaQAAPaUIAAD+7mFyIMK/LWNJ3BAHIn/ZewwAAAA=",
    "importedAt": "2026-06-07T16:15:17.655Z"
  },
  {
    "id": "simple-it-resume-2-59ecb016",
    "title": "Simple IT Resume",
    "slug": "simple-it-resume-2",
    "subtitle": "IT & Tech · Minimal · Modern",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/simple-it-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/simple-it-resume.pdf",
    "googleSlideId": "1qhfFmq4bgiq7G3C_zAfHUhdYYTxeyS3MEJylZhbcny8",
    "copyUrl": "https://docs.google.com/document/d/1qhfFmq4bgiq7G3C_zAfHUhdYYTxeyS3MEJylZhbcny8/template/preview",
    "tags": [
      "IT & Tech",
      "Minimal",
      "Modern",
      "Functional",
      "Skills Section",
      "Projects Section",
      "Summary",
      "Certifications",
      "Multilingual"
    ],
    "atsScore": 87,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal modern format with a dedicated projects section - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Traditional format is universally accepted across all major ATS systems globally",
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAACwAwCdASoUABwAPzmSvFivKiWjqAqp4CcJaQAAPlEdxQbNt/wUAAD+7jgCwMBcq4o9FKaKuRw/4qUEirwXcqWYgeq+RHgAAAA=",
    "importedAt": "2026-06-07T16:15:19.819Z"
  },
  {
    "id": "mit-resume-2-237b7d5e",
    "title": "MIT Resume",
    "slug": "mit-resume-2",
    "subtitle": "IT & Tech · Functional · Skills Section",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/mit-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/mit-resume.pdf",
    "googleSlideId": "1BBPUi2thIyo3LT0ZaKItIZmzbDknj78AiWeGGsiuuXo",
    "copyUrl": "https://docs.google.com/document/d/1BBPUi2thIyo3LT0ZaKItIZmzbDknj78AiWeGGsiuuXo/template/preview",
    "tags": [
      "IT & Tech",
      "Functional",
      "Skills Section",
      "Projects Section",
      "Achievements",
      "Multilingual",
      "Volunteer Work"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a dedicated projects section - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAwCdASoUABwAPzmIvFSvKKYjKA1R4CcJaWtPABx1XwAA/u5iGQ0st4k9KFq3NuwQWX2MN4SdUAAA",
    "importedAt": "2026-06-07T16:15:26.636Z"
  },
  {
    "id": "combination-resume-2-81091073",
    "title": "Combination Resume",
    "slug": "combination-resume-2",
    "subtitle": "Creative & Design · Creative Layout · Senior Level",
    "category": "creative",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/combination-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/combination-resume.pdf",
    "googleSlideId": "172ED6NJ-dZKnMPsMEdR6fdhOy2mRGCosZSpl4Z_FO-8",
    "copyUrl": "https://docs.google.com/document/d/172ED6NJ-dZKnMPsMEdR6fdhOy2mRGCosZSpl4Z_FO-8/template/preview",
    "tags": [
      "Creative & Design",
      "Creative Layout",
      "Senior Level",
      "Skills Section",
      "Projects Section",
      "Certifications",
      "Publications",
      "Volunteer Work"
    ],
    "atsScore": 60,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A visually striking professional format with a unique visual layout - ideal for creative professionals and designers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive Creative & Design applicant pools. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Unique visual layout helps you immediately stand out in competitive creative applicant pools"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAAAwBACdASoUABwAPzmAt1UvJyUjMBgMAeAnCWUAAC5pqAZBMWmKI+oUMoAA/hC9n/y1VoAa2pvQmX/3pAKscWlhlL6472SinmqBEqZ/Zy6AAA==",
    "importedAt": "2026-06-07T16:15:33.253Z"
  },
  {
    "id": "material-handler-resume-2-bc601aa7",
    "title": "Material Handler Resume",
    "slug": "material-handler-resume-2",
    "subtitle": "IT & Tech · Minimal · Skills Section",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/material-handler-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/material-handler-resume.pdf",
    "googleSlideId": "1QuYpcOvLdMWLmPP_ORZov2CXWo0nV4cVuYJiMfQOvpE",
    "copyUrl": "https://docs.google.com/document/d/1QuYpcOvLdMWLmPP_ORZov2CXWo0nV4cVuYJiMfQOvpE/template/preview",
    "tags": [
      "IT & Tech",
      "Minimal",
      "Skills Section",
      "Projects Section",
      "Summary",
      "Certifications"
    ],
    "atsScore": 82,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal professional format with a dedicated projects section - ideal for IT professionals and developers who want to showcase technical expertise clearly.",
    "overview": "Professionally structured layout trusted by recruiters across IT & Tech roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Professional summary gives recruiters a compelling 5-second overview of your career value"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAAAQBACdASoUABwAPzWAt1OvP6Uit/VYA/AmiWkAACl8OTq7OajQPBJmAAD+y/rMkLfwr5ELfhshW8VxzVDddtA58ZFEFtNR5Ew6BjAA",
    "importedAt": "2026-06-07T16:15:35.533Z"
  },
  {
    "id": "graduate-resume-2-d5ff46ae",
    "title": "Graduate Resume",
    "slug": "graduate-resume-2",
    "subtitle": "IT & Tech · Minimal · Creative Layout",
    "category": "it",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/graduate-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/graduate-resume.pdf",
    "googleSlideId": "1ucj3y1UhgUfXd0xKb588cLRSjHsvvHC0khFFrtfjImA",
    "copyUrl": "https://docs.google.com/document/d/1ucj3y1UhgUfXd0xKb588cLRSjHsvvHC0khFFrtfjImA/template/preview",
    "tags": [
      "IT & Tech",
      "Minimal",
      "Creative Layout",
      "Skills Section",
      "Projects Section",
      "Objective",
      "Multilingual",
      "Publications"
    ],
    "atsScore": 63,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, minimal professional format with a dedicated projects section - ideal for IT professionals and developers who want to stand out in competitive creative fields.",
    "overview": "Distinctive layout designed to help you stand out in competitive IT & Tech applicant pools. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAABQAwCdASoUABwAPzmWwlovKqckKAgB4CcJaQAALdDBoXmYQAD+ycsI91cFTlD0tJcqC8ITPkLdhC65AAA=",
    "importedAt": "2026-06-07T16:15:43.960Z"
  },
  {
    "id": "accountant-resume-2-eac8cb3d",
    "title": "Accountant Resume",
    "slug": "accountant-resume-2",
    "subtitle": "Finance & Business · Functional · Senior Level",
    "category": "finance",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/accountant-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/accountant-resume.pdf",
    "googleSlideId": "1JXzVaQyQl8n7uT-20xD6tT7Dh1ktLGXplD2rHBNkxpg",
    "copyUrl": "https://docs.google.com/document/d/1JXzVaQyQl8n7uT-20xD6tT7Dh1ktLGXplD2rHBNkxpg/template/preview",
    "tags": [
      "Finance",
      "Functional",
      "Senior Level",
      "Skills Section",
      "Certifications",
      "Achievements",
      "Multilingual"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for finance and business professionals who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Finance & Business roles. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAADwAwCdASoUABwAPzmOvlevKaYjqAqp4CcJaQAAKWQoft7MS1cGWsYAAP7HJlJ/Z4FMEKxwr9J5zcAKV+kulO8E6lvsgGNUiHiGBgSAAAA=",
    "importedAt": "2026-06-07T16:15:44.159Z"
  },
  {
    "id": "teenager-resume-with-no-work-experience-2-0d500dab",
    "title": "Teenager Resume with No Work Experience",
    "slug": "teenager-resume-with-no-work-experience-2",
    "subtitle": "Professional · Skills Section · Projects Section",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/teenager-resume-with-no-work-experience.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/teenager-resume-with-no-work-experience.pdf",
    "googleSlideId": "1OiXuKb35_PMDPb3gTLb6XhXy00Clmstw-cIgi05iH4I",
    "copyUrl": "https://docs.google.com/document/d/1OiXuKb35_PMDPb3gTLb6XhXy00Clmstw-cIgi05iH4I/template/preview",
    "tags": [
      "Professional",
      "Skills Section",
      "Projects Section",
      "Multilingual",
      "Volunteer Work",
      "References"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmgAAABXRUJQVlA4IFwAAACwAwCdASoUABwAPzmMwVcvKSejqAqp4CcJaQAALnhYt2sBiMZyAAD+5zYyxRvJOdt5AsCNRrRxY+c8kuCoU/xJ0tNiGfhmiuqPzfXYCWss/YTZYstFu58GUAAAAA==",
    "importedAt": "2026-06-07T16:15:51.694Z"
  },
  {
    "id": "applicant-tracking-system-resume-2-56add8f1",
    "title": "Applicant Tracking System Resume",
    "slug": "applicant-tracking-system-resume-2",
    "subtitle": "Professional · ATS Friendly · Functional",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/applicant-tracking-system-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/applicant-tracking-system-resume.pdf",
    "googleSlideId": "1X3SztNPqlX_pL2CLVwc_Mjm43a3z-Vslpk1SWKB8jc0",
    "copyUrl": "https://docs.google.com/document/d/1X3SztNPqlX_pL2CLVwc_Mjm43a3z-Vslpk1SWKB8jc0/template/preview",
    "tags": [
      "Professional",
      "ATS Friendly",
      "Functional",
      "Senior Level",
      "Skills Section",
      "Projects Section",
      "Summary",
      "Multilingual"
    ],
    "atsScore": 89,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format with a compelling professional summary - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRmYAAABXRUJQVlA4IFoAAADwAwCdASoUABwAPzmUwFmvKiajqAgB4CcJZwAAL22tPQsatWPL/xAAAP7fUFWGdUW6PUZ6U3XkL8IvHybYl06zd+R3Y+/fhjk41I+DiC11mmivBhd23HgAAAA=",
    "importedAt": "2026-06-07T16:15:52.365Z"
  },
  {
    "id": "new-grad-nurse-resume-2-ea06a1cf",
    "title": "New Grad Nurse Resume",
    "slug": "new-grad-nurse-resume-2",
    "subtitle": "Healthcare · Senior Level · Skills Section",
    "category": "medical",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/new-grad-nurse-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/new-grad-nurse-resume.pdf",
    "googleSlideId": "17OHkrvtfuyNMZj7h3_krR62wyMeDxpFKryJuCSUyQjE",
    "copyUrl": "https://docs.google.com/document/d/17OHkrvtfuyNMZj7h3_krR62wyMeDxpFKryJuCSUyQjE/template/preview",
    "tags": [
      "Healthcare",
      "Senior Level",
      "Skills Section",
      "Projects Section",
      "Certifications",
      "Volunteer Work"
    ],
    "atsScore": 75,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for healthcare professionals who want to make a strong, lasting first impression.",
    "overview": "Clean clinical format structured to meet the expectations of healthcare recruiters. The dedicated projects section makes it effective for showcasing real-world work and problem-solving ability.",
    "tips": [
      "Projects section compensates for limited professional experience in junior and entry-level roles",
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRn4AAABXRUJQVlA4IHIAAABwBACdASoUABwAPzmUv1mvKaajqAgB4CcJZQDMWA8MW1B0Q6kG8e14/maAAAD+AScXqn08GAYNR3dXATx7xIbwq+Kv74+Q+FCJE0KRBn/d0UqKKPqO/eEbOhzN20Lh2sWr9MFnoXjM11KJ8bfXjAAAAAA=",
    "importedAt": "2026-06-07T16:16:01.770Z"
  },
  {
    "id": "waiter-resume-2-4512546c",
    "title": "Waiter Resume",
    "slug": "waiter-resume-2",
    "subtitle": "Professional · ATS Friendly · Senior Level",
    "category": "professional",
    "thumbnail": "https://cdn.stabiliq.in/resume-templates/thumbnails/waiter-resume.webp",
    "pdfPreview": "https://cdn.stabiliq.in/resume-templates/pdfs/waiter-resume.pdf",
    "googleSlideId": "1IwUfHRmZqK1BmGe7dmpQNtbhkmqfZFKIMcDmEwnnnCs",
    "copyUrl": "https://docs.google.com/document/d/1IwUfHRmZqK1BmGe7dmpQNtbhkmqfZFKIMcDmEwnnnCs/template/preview",
    "tags": [
      "Professional",
      "ATS Friendly",
      "Senior Level",
      "Skills Section",
      "Certifications",
      "Achievements",
      "Multilingual",
      "Volunteer Work"
    ],
    "atsScore": 87,
    "isPopular": false,
    "isFree": true,
    "featured": false,
    "description": "A clean, structured professional format - ideal for professionals across all industries who want to make a strong, lasting first impression.",
    "overview": "Professionally structured layout trusted by recruiters across Professional roles. The skills section allows recruiters to instantly verify technical and professional competencies.",
    "tips": [
      "Skills section helps recruiters quickly identify your core competencies at a glance",
      "Multilingual-ready structure broadens your applicability to international job markets",
      "Dedicated certifications section ensures professional credentials get the visibility they deserve"
    ],
    "blurDataUrl": "data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAACwAwCdASoUABwAPzmUwVmvKicjqAgB4CcJZwAALH/ZKDgblB2oAAD+AJ+gN+/iZA+0oTblUIrcV+UyCOFl4qRHHzrV/Hneb4LEBDN+Q6aAAA==",
    "importedAt": "2026-06-07T16:16:04.644Z"
  }
]